import * as firebase from "firebase/app";
import "firebase/firestore";
import axios from "axios";
import { desofuscarJSON } from '../utilidades'

var firebaseConfig = {
	apiKey: "AIzaSyB6dUXTGGN7cxgWV7an4_BPMrz-0Eg2R7o",
	//authDomain: "restaurantes-c2df2.firebaseapp.com",
	databaseURL: "https://restaurantes-c2df2.firebaseio.com",
	projectId: "restaurantes-c2df2",
	storageBucket: "restaurantes-c2df2.appspot.com",
	messagingSenderId: "840398364086",
	appId: "1:840398364086:web:4e518e4c03d720671df517"
};

export default {
  data: () => ({
    axios: null,
		firestore: null,
		accesoInicialCargado: false,
		datos: {
			id: '',
			nombre: '',
			acceso: {
				restaurante: '',
				código: '',
			}
		},
		modo: 'DESARROLLO'
	}),
	watch: {
		'datos': {
			handler: function() {
				this.axios.defaults.headers.common['X-Restaurante-ID'] = this.datos ? this.datos.id : ''
				this.axios.defaults.headers.common['X-Restaurante-Codigo-De-Acceso'] = this.datos ? this.datos.acceso.código : ''
				this.axios.defaults.headers.common['X-Restaurante-Nombre-De-Acceso'] = this.datos ? this.datos.acceso.restaurante : ''
			},
			deep: true
		}
	},
	created: function () {
		//console.log('Vuetify: ', this.$vuetify)
		firebase.initializeApp(firebaseConfig)
		this.firestore = firebase.firestore()

		this.axios = axios.create({
			baseURL: 'https://us-central1-restaurantes-c2df2.cloudfunctions.net/api/v1/servicio',
			timeout: 30000,
			//headers: {'X-Custom-Header': 'foobar'}
		});

		this.accesoInicial()
	},
	methods: {
		accesoInicial: function() {
			//Común para todos los clientes. Revisar si es necesario diferenciarlos. No lo sería si esan en dominios diferentes...
			let v = localStorage.getItem('restaurantes.servicio')
			if (!v) {
				this.accesoInicialCargado = true
				return
			}

			let d = desofuscarJSON(v)
			if (!d) {
				this.accesoInicialCargado = true
				return
			}

			this.axios.post('/acceso', d.acceso).then(rta => {
				this.datos = d
				this.accesoInicialCargado = true
			}).catch(err => {
				this.accesoInicialCargado = true
			})
		},
		cerrarSesión: function() {
			this.datos = null
			localStorage.removeItem('restaurantes.servicio')
		},
		actualizarListadoDesdeFirestore: function(listado, change) {
			let obj = Object.assign({'id': change.doc.id}, change.doc.data())
			if (change.type === "added") {
					listado.push(obj)
			} else if (change.type === "modified") {
					for (let i in listado) {
						if (listado[i].id == change.doc.id) {
							this.$set(listado, i, obj)
							break
						}
					}
			} else if (change.type === "removed") {
					let idx = -1
					for (let i in listado) {
						if (listado[i].id == change.doc.id) {
							idx = i
							break
						}
					}
					listado.splice(idx, 1)
			}

			return obj
		},
	}
};